import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

export default {
  stats: [],
  page: 1,
  total: 10,
  limit: 10,
  sorting: {
    sort_by: SORT_ORDER.TOTAL_AMOUNT,
    sort_direction: SORT_DIRECTION.ASC,
  },
  total_partner_share: '0.00',

  loading: false,
  error: null,
  appsList: [],
  statsData: null,
  appData: null,

  actionLoading: false,
}
